import { Grid, styled } from '@silverstein-properties/inspirelabs-ui';

export const SkeletonGrid = styled(Grid)(({ theme }) => ({
  marginTop: theme.spacing(8.5),
}));
